import React from 'react'
import {
  Button,
  ButtonActionBar,
  CustomBottomAction,
  DropdownMenu,
  Typography,
} from 'modules/core/components'
import { useTranslation } from 'react-i18next'
import {
  DownOutlined,
  SolutionOutlined,
  DeleteOutlined,
  FileSyncOutlined,
  ShareAltOutlined,
} from '@ant-design/icons'
import { TABLES } from 'modules/core/constants'
import { Popconfirm, Select, Space, Tooltip } from 'antd'
import { generateSelectOptions } from 'modules/core/utils'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import PropTypes from 'prop-types'

const UserActions = ({
  onClickFile,
  onClickSpreadsheets,
  onClickActivity,
  disabled,
  onClickDelete,
  visible,
  loading,
  onCancelPopConfirm,
  onConfirmPopConfirm,
  hasCreate = false,
  onClickCreate = () => {},
  extraButtons,
  currencyOptions,
  onChangeCurrency,
  defaultCurrency,
  onClickUpload = () => {},
  onClickCompartir,
}) => {
  const enabled = true
  const abUploadExcelFile = useFeatureIsOn('ab_upload_excel_file')
  const enableUrls = useFeatureIsOn('enable-urls')
  const { t } = useTranslation()

  const execute = {
    spreadsheets: onClickSpreadsheets,
    file: onClickFile,
  }

  return (
    <ButtonActionBar position={'space-between'}>
      <Space direction="horizontal">
        {enabled && (
          <>
            <Typography.Body>{t('LABEL_CURRENCY')}:</Typography.Body>
            <Select
              bordered={false}
              value={defaultCurrency}
              placeholder={t('ACTION_SELECT')}
              options={generateSelectOptions({ options: currencyOptions })}
              onChange={onChangeCurrency}
            />
          </>
        )}
      </Space>
      <Space direction="horizontal">
        <DropdownMenu
          title={t('ACTION_UPLOAD_FILE')}
          placement="bottomRight"
          menu={TABLES.OPTIONS_DOWNLOAD.map((formatType) => {
            return {
              title: formatType.name,
              key: formatType.id,
              disabled,
              onClick: execute[formatType.id],
            }
          })}
        >
          <Button.PrimaryWhitRightIcon
            icon={<DownOutlined />}
            disabled={disabled}
            title="ACTION_UPLOAD_FILE"
          />
        </DropdownMenu>
        <CustomBottomAction extraButtons={extraButtons} />
        {enableUrls && (
          <Button.Icon
            title="ACTION_SHARE"
            icon={<Typography.Icon icon={ShareAltOutlined} />}
            onClick={onClickCompartir}
          />
        )}
        <DropdownMenu
          title={t('ACTION_MORE')}
          menu={[
            {
              title: t('ACTION_ACTIVITIES'),
              icon: <SolutionOutlined />,
              onClick: onClickActivity,
            },
            ...(abUploadExcelFile
              ? [
                  {
                    title: t('LABEL_PROCESS_UPLOAD'),
                    icon: <FileSyncOutlined />,
                    onClick: onClickUpload,
                  },
                ]
              : []),
            {
              title: (
                <Tooltip title={t('DELETE_ALL_INFORMATIVE_TOOLTIP_TITLE')}>
                  {t('ACTION_DELETE_ALL')}
                </Tooltip>
              ),
              icon: <DeleteOutlined />,
              onClick: onClickDelete,
            },
          ]}
        />
        <Popconfirm
          title={t('POPCONFIRM_DELETE_ALL_PAGES')}
          placement="right"
          okText={t('ACTION_DELETE')}
          okButtonProps={{ loading }}
          cancelButtonProps={{ disabled: loading }}
          onConfirm={onConfirmPopConfirm}
          cancelText={t('ACTION_CANCEL')}
          onCancel={onCancelPopConfirm}
          visible={visible}
        />
      </Space>
    </ButtonActionBar>
  )
}

UserActions.propTypes = {
  extraButtons: PropTypes.any,
  defaultCurrency: PropTypes.any,
  onClickUpload: PropTypes.func,
}

export default UserActions
